/* Match the owner's shipping policy. No earliest-date promise or artificial floor. */
(() => {
  const render = (root = document) => {
    root.querySelectorAll('[data-delivery], [data-getby]').forEach(el => {
      el.textContent = 'Free priority shipping Australia-wide · Estimated 5–9 business days from dispatch';
      el.hidden = false;
    });
    root.querySelectorAll('[data-checkpoints]').forEach(el => {
      const values = {'[data-cp-ordered]':'Order placed','[data-cp-processed]':'Same-day processing','[data-cp-delivered]':'5–9 business days from dispatch'};
      Object.entries(values).forEach(([selector,text]) => { const node = el.querySelector(selector); if (node) node.textContent = text; });
    });
  };
  window.TDDDates = {render,renderCheckpoints:render};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => render()); else render();
  document.addEventListener('shopify:section:load', event => render(event.target));
})();
